import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { ISiteDesign } from '@fi-shared/models';

@Injectable()
export class FiCustomerSettingsService {
    constructor(private fiBackend: FiBackendService) {}

    getCustomerSettings() {
        return this.fiBackend.fetchData<ISiteDesign>('Core/CustomerSettings/GetCustomerSettings');
    }

    saveCustomerSettings(customerSettings: ISiteDesign) {
        return this.fiBackend.fetchDataPost('Core/CustomerSettings/SaveCustomerSettings', customerSettings);
    }
}
